import {FormType} from '../../../../../blocks/FormBlock'
import {copy} from '../../../../../../util/fieldscopy'

const sameAsClientData: FormType = {
	id: 15,
	parent_id: 0,
	channel: 'radio',
	name: 'address',
	label: copy?.address?.label || 'Adres',
	required: true,
	options: [
		{
			amount: null,
			path: 'same_as_client',
			title: copy?.address?.same_as_client || 'Zelfde adres als klantengegevens'
		},
		{
			amount: null,
			path: 'other',
			title: copy?.address?.other_person || 'Gebruik persoonlijk adres'
		}
	]
}

export default sameAsClientData
